var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 873,
    height: "auto",
    viewBox: "0 0 873 988",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M431.074 -268.67C413.826 -259.815 398.268 -247.679 383.737 -233.595C250.294 -104.281 154.559 53.4015 54.3416 207.75C-21.8464 325.094 -102.683 441.43 -207.126 536.506C-264.667 588.855 -340.379 636.736 -416.51 618.494C-469.82 605.722 -510.932 561.919 -533.701 512.8C-556.469 463.681 -560.878 422.232 -567.814 368.68C-577.776 477.267 -557.054 661.353 -435.014 814.631C-333.151 942.519 -148.169 1013.4 5.22723 953.355C88.4946 920.76 153.837 854.809 207.056 783.823C306.918 650.66 372.307 495.635 426.603 338.983C475.276 198.558 622.132 -247.708 873 -25.1504C834.846 -88.0206 750.707 -181.561 675.637 -231.339C617.884 -269.615 549.773 -291.626 478.268 -283.218C461.787 -281.253 445.798 -276.324 431.074 -268.67Z",
    fill: "url(#paint0_linear_147_594)",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M428.074 -255.67C410.826 -246.815 395.268 -234.679 380.737 -220.595C247.294 -91.2808 151.559 66.4015 51.3416 220.75C-24.8464 338.094 -105.683 454.43 -210.126 549.506C-267.667 601.855 -343.379 649.736 -419.51 631.494C-472.82 618.722 -513.932 574.919 -536.701 525.8C-559.469 476.681 -563.878 435.232 -570.814 381.68C-580.776 490.267 -560.054 674.353 -438.014 827.631C-336.151 955.519 -151.169 1026.4 2.22723 966.355C85.4946 933.76 150.837 867.809 204.056 796.823C303.918 663.66 369.307 508.635 423.603 351.983C472.276 211.558 619.132 -234.708 870 -12.1504C831.846 -75.0206 747.707 -168.561 672.637 -218.339C614.884 -256.615 546.773 -278.626 475.268 -270.218C458.787 -268.253 442.798 -263.324 428.074 -255.67Z",
    fill: "url(#paint1_linear_147_594)",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_147_594",
    x1: 862.212,
    y1: 345.009,
    x2: -705.492,
    y2: 345.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FF0104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#BF0144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7C0086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4800BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#2200E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0A00F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#0200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2400DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#7A0088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FF0104"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_147_594",
    x1: 859.212,
    y1: 358.009,
    x2: -708.492,
    y2: 358.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FF0104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#BF0144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7C0086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4800BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#2200E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0A00F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#0200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2400DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#7A0088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FF0104"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.a487b63e3f334d1dcf6ddaf9298f4d21.svg";
export { ForwardRef as ReactComponent };